module.exports = __webpack_public_path__ + "img/j4.5b852cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slideShow/j4.jpg
// module id = H4gL
// module chunks = 1